import React, { useEffect, useState } from 'react';
import formulaService from '../../../../services/formulaService';

export const FormulaAuditModal = ({ formula, initialTab = 'versions', onClose }) => {
  const [activeTab, setActiveTab] = useState(initialTab);
  const [versions, setVersions] = useState([]);
  const [audits, setAudits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (formula?.formulaId) {
      setLoading(true);
      Promise.all([
        formulaService.getVersions(formula.formulaId),
        formulaService.getAuditHistory(formula.formulaId)
      ])
        .then(([vList, aList]) => {
          setVersions(vList || []);
          setAudits(aList || []);
        })
        .catch(err => console.error(err))
        .finally(() => setLoading(false));
    }
  }, [formula]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content-lg" onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
          <div>
            <h2 style={{ margin: 0, fontSize: '18px', color: '#0f172a' }}>
              Formula History & Audit: {formula?.formulaName}
            </h2>
            <span style={{ fontSize: '13px', color: '#64748b' }}>
              Formula Code: {formula?.formulaCode}
            </span>
          </div>
          <button
            onClick={onClose}
            style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#64748b' }}
          >
            ✕
          </button>
        </div>

        {/* Tab Toggle */}
        <div style={{ display: 'flex', gap: '12px', borderBottom: '1px solid #e2e8f0' }}>
          <button
            onClick={() => setActiveTab('versions')}
            style={{
              padding: '8px 16px',
              border: 'none',
              background: 'none',
              fontWeight: 600,
              fontSize: '13.5px',
              cursor: 'pointer',
              color: activeTab === 'versions' ? '#2563eb' : '#64748b',
              borderBottom: activeTab === 'versions' ? '2px solid #2563eb' : 'none'
            }}
          >
            📜 Version History ({versions.length})
          </button>
          <button
            onClick={() => setActiveTab('audit')}
            style={{
              padding: '8px 16px',
              border: 'none',
              background: 'none',
              fontWeight: 600,
              fontSize: '13.5px',
              cursor: 'pointer',
              color: activeTab === 'audit' ? '#2563eb' : '#64748b',
              borderBottom: activeTab === 'audit' ? '2px solid #2563eb' : 'none'
            }}
          >
            🛡️ Audit Trail ({audits.length})
          </button>
        </div>

        {loading ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>
            Loading audit records...
          </div>
        ) : activeTab === 'versions' ? (
          <div style={{ border: '1px solid #e2e8f0', borderRadius: '10px', overflow: 'hidden' }}>
            <table className="formula-table">
              <thead>
                <tr>
                  <th>Version</th>
                  <th>Mathematical Expression</th>
                  <th>Change Reason</th>
                  <th>Status</th>
                  <th>Created By & Date</th>
                </tr>
              </thead>
              <tbody>
                {versions.length === 0 ? (
                  <tr>
                    <td colSpan={5} style={{ textAlign: 'center', padding: '24px', color: '#94a3b8' }}>
                      No versions recorded.
                    </td>
                  </tr>
                ) : (
                  versions.map(v => (
                    <tr key={v.versionId}>
                      <td>
                        <span style={{ fontWeight: 700, color: '#1e40af' }}>
                          v{v.versionNumber}
                        </span>
                      </td>
                      <td>
                        <span style={{ fontFamily: 'monospace', fontWeight: 600, color: '#0369a1' }}>
                          {v.expression}
                        </span>
                      </td>
                      <td style={{ color: '#475569', fontSize: '13px' }}>
                        {v.changeReason || 'Initial version'}
                      </td>
                      <td>
                        <span className={`status-badge status-${(v.status || 'draft').toLowerCase()}`}>
                          {v.status}
                        </span>
                      </td>
                      <td style={{ fontSize: '12.5px', color: '#64748b' }}>
                        <div>{v.createdBy}</div>
                        <div>{new Date(v.createdAt).toLocaleString()}</div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ border: '1px solid #e2e8f0', borderRadius: '10px', overflow: 'hidden' }}>
            <table className="formula-table">
              <thead>
                <tr>
                  <th>Action</th>
                  <th>Summary</th>
                  <th>Performed By</th>
                  <th>Timestamp</th>
                </tr>
              </thead>
              <tbody>
                {audits.length === 0 ? (
                  <tr>
                    <td colSpan={4} style={{ textAlign: 'center', padding: '24px', color: '#94a3b8' }}>
                      No audit events recorded yet.
                    </td>
                  </tr>
                ) : (
                  audits.map(a => (
                    <tr key={a.auditId}>
                      <td>
                        <span style={{
                          fontWeight: 600,
                          fontSize: '12px',
                          padding: '3px 8px',
                          borderRadius: '4px',
                          background: a.action === 'Created' ? '#dcfce7' : a.action === 'Activated' ? '#e0f2fe' : '#f1f5f9',
                          color: a.action === 'Created' ? '#15803d' : a.action === 'Activated' ? '#0369a1' : '#334155'
                        }}>
                          {a.action}
                        </span>
                      </td>
                      <td style={{ color: '#334155', fontSize: '13px' }}>
                        {a.changeSummary || '-'}
                      </td>
                      <td style={{ fontWeight: 500, fontSize: '13px' }}>
                        {a.performedBy}
                      </td>
                      <td style={{ fontSize: '12.5px', color: '#64748b' }}>
                        {new Date(a.performedAt).toLocaleString()}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
          <button className="btn-primary-gradient" onClick={onClose}>
            Close History
          </button>
        </div>
      </div>
    </div>
  );
};

export default FormulaAuditModal;
